import axios from "../util/axios";
export default {
  state() {
    return {
      message: [],
      unread: [],
    };
  },
  mutations: {
    setMessage(state, data) {
      state.message = data;
    },
    setUnready(state, data) {
      let unread = [];
      for (const item of state.message) {
        if (item.type == 0) {
          unread.push(item);
          if (unread.length >= 3) {
            break;
          }
        }
      }
      state.unread = unread;
    },
  },
  actions: {
    getMessage({ commit }) {
      axios.post_form("/member/email/emaillist", {}).then((res) => {
        res = res.data;
        if (res.status == 200) {
          let unread = [];
          for (const item of res.data) {
            if (item.type == 0) {
              unread.push(item);
              if (unread.length >= 3) {
                break;
              }
            }
          }
          commit("setMessage", res.data);
          commit("setUnready");
        }
      });
    },
  },
};
